import React from 'react';
import { Link } from 'react-router-dom';

function CTASection({
  title = 'Ready to help Ron win Big Flats?',
  body = 'Sign up to volunteer, request a yard sign, or just say hello.',
  ctaLabel = 'Get Involved',
  ctaTo = '/contact',
}) {
  return (
    <section className="cta-strip">
      <div className="container cta-strip__inner">
        <div>
          <h2>{title}</h2>
          <p>{body}</p>
        </div>
        <Link to={ctaTo} className="btn btn--primary">{ctaLabel}</Link>
      </div>
    </section>
  );
}

export default CTASection;
